import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Container from "@mui/material/Container";
import CustomContainer from "../CustomContainer";

import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import { Typography } from "@mui/material";

ChartJS.register(ArcElement, Tooltip, Legend);

export default function CategoriesRankingGraphicCard({
  wasUserFound,
  isLoading,
  categorias,
}) {
  const series = !!categorias && categorias.map(({ count }) => Number(count));

  const labels =
    !!categorias &&
    categorias.map(({ name }) =>
      name.length > 13 ? `${name.slice(0, 13)}.` : name
    );

  const data = {
    labels: !!labels && labels.slice(0, 5),
    datasets: [
      {
        data: !!series && series.slice(0, 5),
        backgroundColor: categorias.map(({ color }) => color),
      },
    ],
  };

  const options = {
    aspectRatio: 2,
    plugins: {
      legend: {
        position: "right",
      },
    },
  };

  return isLoading ? (
    <Container
      sx={{
        alignItems: "center",
        display: "flex",
        height: "200px",
        justifyContent: "space-around",
        p: 0,
      }}
    >
      <CircularProgress />
    </Container>
  ) : !!wasUserFound ? (
    <CustomContainer
      sx={{
        alignItems: "center",
        display: "flex",
        height: "200px",
        justifyContent: "center",
        p: 0,
      }}
    >
      {
        <Box
          alignSelf="center" // para manter o tamanho do gráfico
        >
          <Doughnut data={data} options={options} />
        </Box>
      }
    </CustomContainer>
  ) : (
    <Container
      sx={{
        alignItems: "center",
        display: "flex",
        height: "200px",
        justifyContent: "space-around",
        p: 0,
      }}
    >
      <Typography component="p" textAlign="center" variant="h4">
        Associado não encontrado
      </Typography>
    </Container>
  );
}
